import { ref, watch } from 'vue'

// Module-level reactive ref shared between AppShell (writer) and pages (readers).
// AppShell updates this when the user clicks a tag — no page reload needed.
export const sharedActiveTagId = ref<string | null>(null)

// Call this at the top level of <script setup> to re-run a callback whenever
// the active tag changes. The watcher is automatically cleaned up on unmount.
export function onActiveTagChange(callback: () => void): void {
  watch(sharedActiveTagId, callback)
}
